export default "__VITE_ASSET__50bfc9a4__"